import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import Loading from "../../Components/Loading/Loading";
import * as service from "./service"
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PlaylistCard from "../../Components/PlaylistCard/PlaylistCard";
import useScrollPosition from "../../Components/ScrollPosition/useScrollPosition";
import { useRef } from "react";
import { rowItemCount } from "../../utils/utils";
import { useWindowWidth } from "@react-hook/window-size";
import {imageUrlCheck} from "../../utils/utils";
const Playlist =({video,type,playVideo,downloadPlaylist,b2bId}) =>{
  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  const accessToken = useSelector((state) => state?.accessToken?.value);
  const thumbnailOrientation = projectInfo?.projectConfig?.config?.THUMBNAIL_ORIENTATION;

  const [img, setImg] = useState(true);
  const [loading , setLoading] = useState(true);
  const [rowItemsClass,setRowItemsClass] = useState("")
  const [videos , setVideos] = useState([]);
  const [sliceCount ,setSliceCount] =useState(20)
  const [playContent ,setPlayContent] =useState(false)
  
   
  
  const windowSize = useWindowWidth()
  const scrollPosition = useScrollPosition();
  const containerRef = useRef(null);
  const {id} = useParams()
 
 
  const appInfo = {
    projectDetails: projectInfo,
    accessToken: accessToken,
    
  };

  useEffect(()=>{
    window.scroll(0,0)
    
    setLoading(true)
  },[])


 

  useEffect(()=>{
    if(type==="B2bPlaylist"){
      setVideos(video);
      setLoading(false);
      setImg(false);
    }else{
      fetchPlaylistDetails();
    }
    
  },[]);

  useEffect(()=>{
    if(!loading && sliceCount<videos?.videos?.length){
      lazyLoad()
    }
  },[loading,scrollPosition,videos])

  useEffect(() => {
    if(windowSize>980){
      if(projectInfo?.projectConfig?.config?.WEBSITE_ROW_ITEM_COUNT){
        setRowItemsClass(rowItemCount(projectInfo?.projectConfig?.config?.WEBSITE_ROW_ITEM_COUNT))
      }else{
        setRowItemsClass("rowCount4")
      }
    }else{
      setRowItemsClass("")
    }
  }, [projectInfo,windowSize]);

  const fetchPlaylistDetails=async () => {
    setLoading(true)
    try{
        const playlistResponse = await service.getAllVideosOfPlayList(appInfo,id);
        
        if(playlistResponse?.status === 200){
            setVideos(playlistResponse?.data?.data);
            setLoading(false);
            setImg(false);
        }

    }
    catch(err){
        toast.error(err?.response?.data?.message,{
          position:"top-center",  
        });
        setLoading(false)

    }
  }
  const lazyLoad = () => {
    const containerHeight = containerRef?.current?.clientHeight;
    if(scrollPosition + 2200 >= containerHeight){
      setSliceCount(sliceCount+20)
    }
  }

  if(loading){
    return(
        <Loading/>
    )
  }



    return(
        <>
        <div className="playListPage" ref={containerRef}> 
        {videos?.length  ===0 | Object.entries(videos).length === 0  ? 
  
        <h1
              style={{
                color: "#E72A31",
                display:"flex",
                justifyContent:'center',
            
              }}
            >
              No data found
            </h1>
            
:
            <div className="wrapper">
          
                 {
                  videos?.thumbnail ? <div className="backgroundContainer">
                <div className={playContent ? "headingSection-wrap":"headingSection"}>
                   <div className="b2b-warning">
                          <div>
                          <svg height={20} width={20} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#fff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill-rule="evenodd" clip-rule="evenodd" d="M19.5 12C19.5 16.1421 16.1421 19.5 12 19.5C7.85786 19.5 4.5 16.1421 4.5 12C4.5 7.85786 7.85786 4.5 12 4.5C16.1421 4.5 19.5 7.85786 19.5 12ZM21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM11.25 13.5V8.25H12.75V13.5H11.25ZM11.25 15.75V14.25H12.75V15.75H11.25Z" fill="#fff"></path> </g></svg>
                          </div>
                          <div className="message">
                            <div>For Screening Purposes only.</div>
                            <div className="secondSentence">Not available for public viewing</div>
                          </div>
                   </div>
                    <h1 className="heading">{videos.name}</h1>                    
                    <p className="desc">{videos.description}</p>
                  </div>
                  {imageUrlCheck(videos?.thumbnail) ? (
                          <img
                            src={`${videos?.thumbnail}`}
                            alt="Background"
                          />
                        ) : (
                          <img
                            src={
                              `${process.env.REACT_APP_IMAGE_URL}${videos?.thumbnail_350_200}`
                            }
                            alt="Background"
                          />
                        )
                        }
                  <div className="bottomGradient" />   
                </div>
                :
                <div className="headingSection">
                <h1 className="heading">{videos.name}</h1>
                <p className="desc">{videos.description}</p>
              </div>    
              }
                <div className="playlistBody">
                    <div className="playlistContainer">
                        {videos?.videos?.slice(0,sliceCount)?.map((item,index)=>( 
                                 <div className={thumbnailOrientation===`PORTRAIT`?`playlistItems portrait ${rowItemsClass}`:`playlistItems landscape ${rowItemsClass}`}>
                                    <PlaylistCard
                                        data={item}
                                        key={index}
                                        imageUrl={img}
                                        season={false}
                                        metaData={true}
                                        type={type}
                                        playVideo={playVideo}
                                      setPlayContent={b2bId ? setPlayContent : null}
                                    />
                                 </div>
                                 
                        ))        
                        } 
            
                    </div>
                </div>
             
            </div>
        }  
        </div>
        </>
    )
}
export default Playlist;
